import { lazy, Suspense, useState, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { createAppQueryClient } from "./queryClient";

// Development builds only — the import is dropped from production bundles.
const Devtools =
  import.meta.env.DEV && import.meta.env.MODE !== "test"
    ? lazy(() => import("@tanstack/react-query-devtools").then((m) => ({ default: m.ReactQueryDevtools })))
    : null;

/**
 * Mounted inside each portal's protected layout: the cache lives exactly as
 * long as the signed-in session, so logging out (which unmounts the layout)
 * drops every cached screen — nothing carries over to the next account (the
 * next session mounts a brand-new client).
 */
export function AppQueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(createAppQueryClient);
  return (
    <QueryClientProvider client={client}>
      {children}
      {Devtools && (
        <Suspense fallback={null}>
          <Devtools initialIsOpen={false} buttonPosition="bottom-left" />
        </Suspense>
      )}
    </QueryClientProvider>
  );
}
